"use strict";

module.exports = function () {
    return {
        restrict: "E",
        controller: "footer.controller",
        controllerAs: "vm",
        templateUrl: "app/common/directives/partials/footer.html"
    };
}